import React from 'react';

const FourArrowPointIcon = (props) => (
  <svg width={32} height={32} viewBox='0 0 32 32' {...props}>
    <g fill='currentColor' fillRule='evenodd'>
      <g fillRule='nonzero'>
        <path d='M5.082 16.5a1 1 0 0 1 .875-.992l.125-.008H26.76a1 1 0 0 1 .125 1.992l-.125.008H6.082a1 1 0 0 1-1-1Z' />
        <path d='M16.42 5.161a1 1 0 0 0-.991.875l-.008.125V26.84a1 1 0 0 0 1.992.125l.008-.125V6.16a1 1 0 0 0-1-1Z' />
      </g>
      <path d='M25.544 20.956 30 16.5l-4.456-4.456zM7.456 12.044 3 16.5l4.456 4.456zM20.956 7.456 16.5 3l-4.456 4.456zM12.044 25.544 16.5 30l4.456-4.456z' />
    </g>
  </svg>
);

export default FourArrowPointIcon;
